import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/about.scss";

const editorialSections = [
  {
    eyebrow: "01 / The edit",
    title: "Tools worth reaching for",
    copy: [
      `At ${siteConfig.brandName}, we believe the best creative tools make the distance between an idea and the page feel shorter. Our range brings writing, drawing and making essentials into one considered place.`,
      "Every collection is organised around how people actually create: a first sketch, a careful line, a wash of colour or a notebook opened every morning.",
    ],
    image: "/main/about-tools.png",
    imageAlt: "A creator arranging drawing tools at a home studio desk",
  },
  {
    eyebrow: "02 / Our approach",
    title: "A clearer way to choose",
    copy: [
      "Creative shops can be wonderfully abundant, but they should never feel overwhelming. We use plain-language descriptions, useful attributes and focused categories to help each customer compare with confidence.",
      "The result is a practical edit for curious beginners, committed hobbyists and working artists—without pretending that one tool is right for every hand.",
    ],
    image: "/main/about-paper.png",
    imageAlt: "Hands comparing different creative paper textures",
  },
  {
    eyebrow: "03 / The promise",
    title: "From our shelf to your studio",
    copy: [
      `Thoughtful service matters as much as the product itself. ${siteConfig.brandName} is designed around clear delivery information, straightforward returns and friendly product guidance when you need it.`,
      `Questions are always welcome. Our team is available ${siteConfig.contact.hours.toLowerCase()} to help you find the right material for what comes next.`,
    ],
    image: "/main/about-packing.png",
    imageAlt: "An order being carefully packed in recyclable materials",
  },
];

function About() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="about">
      <div className="about__shell">
        <nav className="about__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" onClick={toTop}>Home</Link>
          <span aria-hidden="true">/</span>
          <span aria-current="page">About us</span>
        </nav>

        <header className="about__hero">
          <p className="about__kicker">About {siteConfig.brandName}</p>
          <h1>For every way you make.</h1>
          <p className="about__lede">{siteConfig.description}</p>
        </header>

        <div className="about__editorial">
          {editorialSections.map((section, index) => (
            <section
              className={`about__story${index % 2 === 1 ? " about__story--reverse" : ""}`}
              key={section.title}
            >
              <div className="about__image-wrap">
                <img
                  className="about__image"
                  src={section.image}
                  alt={section.imageAlt}
                  loading={index === 0 ? "eager" : "lazy"}
                />
              </div>
              <div className="about__story-copy">
                <p className="about__eyebrow">{section.eyebrow}</p>
                <h2>{section.title}</h2>
                {section.copy.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              </div>
            </section>
          ))}
        </div>

        <section className="about__cta" aria-labelledby="about-cta-title">
          <div>
            <p className="about__eyebrow">Start somewhere</p>
            <h2 id="about-cta-title">Find a tool for your next idea.</h2>
          </div>
          <Link className="about__button" to="/shop" onClick={toTop}>
            Explore the shop <span aria-hidden="true">→</span>
          </Link>
        </section>
      </div>
    </main>
  );
}

export default About;
